import React, { Component } from 'react';
import Autosuggest from 'react-autosuggest';
import '../CompanyAutoComplete.css';

class UsersAutocomplete extends Component {
  constructor(props) {
    super(props);
    const searchTerm = props.searchTerm || '';

    this.state = {
      searchTerm,
      suggestions: this.filterCalled(searchTerm),
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.searchTerm !== prevProps.searchTerm) {
      this.setState({ searchTerm: this.props.searchTerm || '' });
    }
  }

  filterCalled = value => {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;
    const { calls, filterValues } = this.props;
    if (filterValues == "emails")
      return calls.filter(item => {
        return item.email.toLowerCase().match(inputValue)
    });
    else {
      return calls.filter(item => {
        if (this.props.allowedUsers) {
          if (item._id && (item.role === 'user' || item.role === 'agent')) {
            return item;
          }
        } else {
          if (item._id) {
            return calls;
          } else {
            return item.toLowerCase().slice(0, inputLength) === inputValue;
          }
        }
      });
    }
  };

  getCalledValue = calls => calls;

  renderSuggestion = calls => {
    if (this.props.allowedUsers) {
      return <div>{calls.email}</div>;
    } else {
      if (calls._id) {
        return <div>{calls.email}</div>;
      } else {
        return <div>{calls}</div>;
      }
    }
  };

  onChange = (event, { newValue }) => {
    if (this.props.usage === 'proposal') {
      this.props.onBillingFieldUpdate({
        currentTarget: { value: newValue, name: this.props.name },
      });
    }

    if (this.props.usage === 'provision') {
      this.props.onChange({
        name: event.target.value,
        value: event.target.value,
        suggestion: event.target.value,
      });
    }

    if (newValue === '') {
      this.props.onChange({ name: this.props.callsItem, value: undefined, suggestion: null });
    }
    this.setState({
      searchTerm: newValue.email || newValue,
    });
  };

  // Autosuggest will call this function every time you need to update suggestions.
  // You already implemented this logic above, so just use it.
  onSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      suggestions: this.filterCalled(value),
    });
  };

  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: [],
    });
  };

  onCalledSelected = (ev, { suggestion, suggestionValue }) => {
    const evObj = { name: this.props.callsItem, value: suggestionValue, suggestion };
    this.props.onChange(evObj);
  };

  render() {
    const { searchTerm, suggestions } = this.state;
    const disabledInput = this.props.disabledAdmin ? this.props.disabledAdmin : false;

    // Autosuggest will pass through all these props to the input.
    const inputProps = {
      placeholder: this.props.placeholder || 'Search caller number...',
      value: searchTerm,
      onChange: this.onChange,
      name: this.props.callsItem,
      requires: 'true',
      type: 'text',
      className: 'form-control',
      disabled: disabledInput,
    };

    // Finally, render it!
    return (
      <div className="autocomplete-container">
        <Autosuggest
          suggestions={suggestions}
          onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
          onSuggestionsClearRequested={this.onSuggestionsClearRequested}
          getSuggestionValue={this.getCalledValue}
          renderSuggestion={this.renderSuggestion}
          inputProps={inputProps}
          shouldRenderSuggestions={() => true}
          onSuggestionSelected={this.onCalledSelected}
        />
      </div>
    );
  }
}

export default UsersAutocomplete;
